export default __webpack_public_path__ + "static/media/Gloves of the First Circle.488c9731.jpg";